import { LOGIN_TYPES } from "./types";
import apiClient from '../../utils/apiConfig';

// Friends list action creators
export const fetchFriendsList = () => async (dispatch, getState) => {
  try {
    dispatch({ type: LOGIN_TYPES.FETCH_FRIENDS_LIST_REQUEST });
    
    const token = getState().auth?.token || localStorage.getItem("burrowtoken");
    
    if (!token) {
      throw new Error("Authentication token not found");
    }
    
    console.time('fetch-friends-list');
    const response = await apiClient.get('/api/user/friends-list', {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    });
    console.timeEnd('fetch-friends-list');
    
    if (response.data.success) {
      dispatch({
        type: LOGIN_TYPES.FETCH_FRIENDS_LIST_SUCCESS,
        payload: {
          friendsList: response.data.friendsList || []
        }
      });
      
      return { 
        success: true, 
        friendsList: response.data.friendsList 
      };
    } else {
      throw new Error(response.data.message || "Failed to fetch friends list");
    }
  } catch (error) {
    console.error("Error fetching friends list:", error);
    
    dispatch({
      type: LOGIN_TYPES.FETCH_FRIENDS_LIST_FAILURE,
      payload: {
        error: error.response?.data?.message || error.message
      }
    });
    
    return { 
      success: false, 
      error: error.response?.data?.message || error.message 
    };
  }
};

export const addFriend = (friendBurrowerId) => async (dispatch, getState) => {
  try {
    dispatch({ type: LOGIN_TYPES.ADD_FRIEND_REQUEST });
    
    const token = getState().auth?.token || localStorage.getItem("burrowtoken");
    
    if (!token) {
      throw new Error("Authentication token not found");
    }
    
    const response = await apiClient.post(
      '/api/user/friends-list/add-friend',
      { friendBurrowerId },
      {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );
    
    if (response.data.success) {
      dispatch({
        type: LOGIN_TYPES.ADD_FRIEND_SUCCESS,
        payload: {
          friendsList: response.data.friendsList || []
        }
      });
      
      return { 
        success: true, 
        friendsList: response.data.friendsList,
        message: response.data.message
      };
    } else {
      throw new Error(response.data.message || "Failed to add friend");
    }
  } catch (error) {
    console.error("Error adding friend:", error);
    
    dispatch({
      type: LOGIN_TYPES.ADD_FRIEND_FAILURE,
      payload: {
        error: error.response?.data?.message || error.message
      }
    });
    
    return { 
      success: false, 
      error: error.response?.data?.message || error.message 
    };
  }
};

export const removeFriend = (friendId) => async (dispatch, getState) => {
  try {
    dispatch({ type: LOGIN_TYPES.REMOVE_FRIEND_REQUEST });
    
    const token = getState().auth?.token || localStorage.getItem("burrowtoken");
    
    if (!token) {
      throw new Error("Authentication token not found");
    }
    
    const response = await apiClient.delete(`/api/user/friends-list/remove-friend/${friendId}`, {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    });
    
    if (response.data.success) {
      dispatch({
        type: LOGIN_TYPES.REMOVE_FRIEND_SUCCESS,
        payload: {
          friendsList: response.data.friendsList || []
        }
      });
      
      return { 
        success: true, 
        friendsList: response.data.friendsList,
        message: response.data.message
      };
    } else {
      throw new Error(response.data.message || "Failed to remove friend");
    }
  } catch (error) {
    console.error("Error removing friend:", error);
    
    dispatch({
      type: LOGIN_TYPES.REMOVE_FRIEND_FAILURE,
      payload: {
        error: error.response?.data?.message || error.message
      }
    });
    
    return { 
      success: false, 
      error: error.response?.data?.message || error.message 
    };
  }
};

// =============================================
// MEMBERS LIST (all community members)
// "Kin" = close friends / chosen connections, NOT biological family.
// This fetches ALL members for the Members tab.
// =============================================
export const fetchAllMembers = (page = 1, limit = 50) => async (dispatch, getState) => {
  try {
    dispatch({ type: LOGIN_TYPES.FETCH_MEMBERS_REQUEST });

    const token = getState().auth?.token || localStorage.getItem("burrowtoken");

    const response = await apiClient.get('/api/user/members', {
      params: { page, limit },
      headers: { Authorization: `Bearer ${token}` }
    });

    if (response.data.success) {
      dispatch({
        type: LOGIN_TYPES.FETCH_MEMBERS_SUCCESS,
        payload: {
          members: response.data.members || [],
          totalResults: response.data.totalResults || 0,
          currentPage: response.data.currentPage || 1,
          totalPages: response.data.totalPages || 1,
          hasMore: response.data.hasMore || false
        }
      });
      return { success: true, members: response.data.members };
    } else {
      throw new Error(response.data.message || "Failed to fetch members");
    }
  } catch (error) {
    console.error("Error fetching members:", error);
    dispatch({
      type: LOGIN_TYPES.FETCH_MEMBERS_FAILURE,
      payload: { error: error.response?.data?.message || error.message }
    });
    return { success: false, error: error.message };
  }
};
